module.exports = __webpack_public_path__ + "static/media/light_through_the_trees_small.bfcbfacb.jpg";